import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { ReportMapper, ReportCategory } from '@app/mappers/report.mapper';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private apiUrl = environment.cdrBase;

  constructor(private http: HttpClient) {}

  getLessonComplaintCategories(): Observable<ReportCategory[]> {
    return this.http
      .get(`${this.apiUrl}/v3/lesson_complaint_categories`)
      .pipe(map((apiCategories) => ReportMapper.mapApiCategoriesToReportCategories(apiCategories)));
  }

  submitLessonComplaint(
    lessonId: string,
    content: string,
    category: string,
    subcategory: string,
    files: File[]
  ): Observable<boolean> {
    const formData = new FormData();

    formData.append('lesson_complaint[lesson_id]', lessonId);
    formData.append('lesson_complaint[content]', content);
    formData.append('lesson_complaint[category]', category);
    formData.append('lesson_complaint[subcategory]', subcategory);

    files.forEach((file) => {
      formData.append('lesson_complaint[files][]', file, file.name);
    });

    return this.http.post(`${this.apiUrl}/v3/lesson_complaints`, formData).pipe(map(() => true));
  }
}
